import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { SButton } from '@strana-artw/ui-kit';
import { useScreenPlugin } from '@/plugins/vue-screen';
import { useFormValidator } from '@/shared/composables';
import Drawer from '@/shared/ui/Drawer.vue';
import { useAgentProfileStore } from '@/store/agentProfile';
export default {
  name: 'ModalProfile',
  components: {
    SButton: SButton,
    Drawer: Drawer,
    ChangePassword: function ChangePassword() {
      return import('./ChangePassword');
    },
    ChangePasswordSuccess: function ChangePasswordSuccess() {
      return import('@/shared/ui/ChangePasswordSuccess');
    },
    RestorePassword: function RestorePassword() {
      return import('./RestorePassword');
    },
    RestorePasswordSuccess: function RestorePasswordSuccess() {
      return import('@/shared/ui/RestorePasswordSuccess');
    },
    FiredConfirm: function FiredConfirm() {
      return import('@/features/fire-process/ui/FiredConfirm.vue');
    },
    FiredSuccess: function FiredSuccess() {
      return import('@/features/fire-process/ui/FiredSuccess.vue');
    }
  },
  setup: function setup() {
    return _objectSpread({
      agentProfileStore: useAgentProfileStore(),
      screen: useScreenPlugin()
    }, useFormValidator());
  },
  methods: {
    handleClose: function handleClose() {
      this.$refs.drawer.handleCloseStart();
    },
    handleClosed: function handleClosed() {
      this.$modal.close();
    }
  }
};